import { render, staticRenderFns } from "./Offerzone.vue?vue&type=template&id=1ec8f0d4&"
import script from "./Offerzone.vue?vue&type=script&lang=js&"
export * from "./Offerzone.vue?vue&type=script&lang=js&"
import style0 from "./Offerzone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports